__turbopack_context__.v({
  "generateSpinner": "variant-selector-module__sNiZia__generateSpinner",
  "infeasibleIcon": "variant-selector-module__sNiZia__infeasibleIcon",
  "infeasibleTooltip": "variant-selector-module__sNiZia__infeasibleTooltip",
  "infeasibleWrap": "variant-selector-module__sNiZia__infeasibleWrap",
  "tab": "variant-selector-module__sNiZia__tab",
  "tabGenerate": "variant-selector-module__sNiZia__tabGenerate",
  "tabIndicator": "variant-selector-module__sNiZia__tabIndicator",
  "tabLabel": "variant-selector-module__sNiZia__tabLabel",
  "tabList": "variant-selector-module__sNiZia__tabList",
  "tabMeta": "variant-selector-module__sNiZia__tabMeta",
  "tabUnavailable": "variant-selector-module__sNiZia__tabUnavailable",
  "variantSpinnerSpin": "variant-selector-module__sNiZia__variantSpinnerSpin",
  "wrapper": "variant-selector-module__sNiZia__wrapper",
});
